import { render } from "./Terms.vue?vue&type=template&id=571ae14a&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=571ae14a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-571ae14a"

export default script